import Translate from "../translate/Translate";
import { Theme } from "../Theme";

class UIUtil {
    static getDeviceStatusUI(status) {
        let statusTextColor;
        let statusBackgroundColor;
        let statusIcon;
        let statusText;
        let buttonText = Translate("store.button.courtesyCycle");
        let buttonColor = undefined;
        let popupText = Translate("popup.courtesyCycle");

        if (status === "error") {
            statusTextColor = Theme.color.rose500;
            statusBackgroundColor = Theme.color.rose500_01;
            statusIcon = "alert_triangle";
            statusText = Translate("store.deviceStatus.error");
        } else if (status === "standby") {
            statusTextColor = Theme.color.teal500;
            statusBackgroundColor = Theme.color.teal500_007;
            statusIcon = "power_on";
            statusText = Translate("store.deviceStatus.standby");
        } else if (status === "inUse") {
            statusTextColor = Theme.color.indigo550;
            statusBackgroundColor = Theme.color.indigo500_007;
            statusIcon = "refresh_purple";
            statusText = Translate("store.deviceStatus.inUse");
            buttonText = Translate("store.button.killCycle");
            buttonColor = Theme.color.rose500;
            popupText = Translate("popup.killCycle");
        } else if (status === "offline") {
            statusTextColor = Theme.color.gray500;
            statusBackgroundColor = Theme.color.gray500_007;
            statusIcon = "black_out_grey";
            statusText = Translate("store.deviceStatus.offline");
        }

        return { statusTextColor, statusBackgroundColor, statusIcon, statusText, buttonText, buttonColor, popupText };
    }

    static getRoleStatusUI(status) {
        let textColor;
        let backgroundColor;
        let text;

        if (status === "pending") {
            textColor = Theme.color.indigo500;
            backgroundColor = Theme.color.indigo500_007;
            text = "Pending";
        } else if (status === "reject") {
            textColor = Theme.color.rose500;
            backgroundColor = Theme.color.rose500_007;
            text = "Reject";
        } else if (status === "approve") {
            textColor = Theme.color.teal600;
            backgroundColor = Theme.color.teal600_007;
            text = "Approve";
        }

        return { textColor, backgroundColor, text };
    }

    static getRankIcon(rank) {
        let icon;

        if (rank === 1) {
            icon = "rank_one";
        } else if (rank === 2) {
            icon = "rank_two";
        } else if (rank === 3) {
            icon = "rank_three";
        } else {
            icon = "rank_other";
        }

        return { icon };
    }

    static getTicketStatusUI(status) {
        let textColor;
        let backgroundColor;
        let text;

        if (status === "registered") {
            textColor = Theme.color.teal600;
            backgroundColor = Theme.color.teal600_007;
            text = "Registered";
        } else if (status === "carryOut") {
            textColor = Theme.color.indigo500;
            backgroundColor = Theme.color.indigo500_007;
            text = "Carry Out";
        } else if (status === "forwardTheMatter") {
            textColor = Theme.color.rose500;
            backgroundColor = Theme.color.rose500_007;
            text = "Forward The Matter";
        } else if (status === "closed") {
            textColor = Theme.color.gray500;
            text = "Closed";
        }

        return { textColor, backgroundColor, text };
    }
}

export default UIUtil;
